import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { cmsClient } from "@/lib/cmsClient";
import { useSessionStore } from "@/store/session";
import type { Discount } from "../discount.types";
import { parseDiscountResponse } from "../mappers/discount.parse";
import DISCOUNT_CODES_QUERY from "../graphql/DiscountCodes.graphql";

export function useDiscountInfo(): Discount | undefined {
    const discountCode = useSessionStore((s) => s.discountCode);

    const { data } = useQuery<unknown>(DISCOUNT_CODES_QUERY, {
        client: cmsClient,
        variables: { code: discountCode },
        skip: !discountCode,
    });

    const discount: Discount | undefined = useMemo(
        () => parseDiscountResponse(data),
        [data],
    );

    return discount;
}
